<section class="w-full mx-auto min-h-screen flex-col items-center justify-center">
  <div
    class="w-full flex flex-col lg:flex-row items-center justify-start max-sm:h-[70dvh] max-md:h-[80dvh] h-[90dvh] overflow-hidden">
    <div class="min-w-[70%] h-full max-sm:min-h-[60%] max-md:min-h-[50%] max-lg:min-h-[50%] max-xl:min-h-[50%]">
      <div
        class="w-full max-w-[1500px] xl:w-[80%] h-full flex flex-col items-center lg:items-start justify-start lg:justify-center gap-5 p-3 sm:p-10">
        <div
          class="text-3xl md:text-8xl lg:text-10xl xl:text-14xl font-secondary font-extrabold flex flex-col">
          <h1 class="text-secondary-700 text-center lg:text-left md:leading-14 lg:leading-16">
            Dlaczego partnerzy leasingowi wybierają ProcessWay?
          </h1>
          <span class="text-primary-600 inline-block text-center lg:text-left">
            Oto
            @if (isBrowser) {
              <om-number-ticker [countTo]="6" [countDuration]="1500"></om-number-ticker>
            }
            powodów
          </span>
        </div>
        <div
          class="flex flex-col max-lg:max-w-[75%] items-center max-lg:text-center lg:items-start text-md lg:text-lg text-secondary-700 font-semibold gap-5">
          <span>Każdy z nich realnie skraca procesy, zmniejsza koszty i zapobiega konfliktom w leasingu</span>
          <p-button
            (click)="onCtaClick()"
            type="submit"
            label="Przekonaj się"
            styleClass="text-sm md:text-md extra-padding"
            [rounded]="true">
          </p-button>
        </div>
      </div>
    </div>
    <img src="assets/auctions/images/car-front.webp" alt="car-front"
         class="object-cover w-full h-full">
  </div>

  <div class="w-full pt-5 pb-24 px-4 sm:px-6 lg:px-8 mt-8 lg:mt-5">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          class="group relative rounded-2xl overflow-hidden p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-secondary-200 shadow-xl">
          <div class="mb-6">
            <div
              class="inline-flex items-center justify-center w-14 h-14 text-secondary-200 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <ng-icon name="matHandshakeOutline" size="2rem"></ng-icon>
            </div>
          </div>
          <div>
            <h3
              class="font-secondary text-xl font-semibold text-primary-800 mb-3 group-hover:text-slate-700 transition-colors">
              {{ solutionsData[0]?.title }}
            </h3>
            <p class="text-secondary-800 leading-relaxed text-sm font-semibold">
              {{ solutionsData[0]?.content }}
            </p>
          </div>
          <div
            class="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full rounded-b-2xl transition-all duration-500 bg-gradient-to-br from-blue-400 to-blue-500"></div>
        </div>

        <div
          class="group relative rounded-2xl overflow-hidden p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-secondary-200 shadow-xl">
          <div class="mb-6">
            <div
              class="inline-flex items-center justify-center w-14 h-14 text-secondary-200 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <ng-icon name="tablerChartArrows" size="2rem"></ng-icon>
            </div>
          </div>
          <div>
            <h3
              class="font-secondary text-xl font-semibold text-primary-800 mb-3 group-hover:text-slate-700 transition-colors">
              {{ solutionsData[1]?.title }}
            </h3>
            <p class="text-secondary-800 leading-relaxed text-sm font-semibold">
              {{ solutionsData[1]?.content }}
            </p>
          </div>
          <div
            class="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full rounded-b-2xl transition-all duration-500 bg-gradient-to-br from-emerald-500 to-emerald-600"></div>
        </div>

        <div
          class="group relative rounded-2xl overflow-hidden p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-secondary-200 shadow-xl">
          <div class="mb-6">
            <div
              class="inline-flex items-center justify-center w-14 h-14 text-secondary-200 rounded-xl bg-gradient-to-br from-amber-500 to-amber-600 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <ng-icon name="matHomeRepairServiceOutline" size="2rem"></ng-icon>
            </div>
          </div>
          <div>
            <h3
              class="font-secondary text-xl font-semibold text-primary-800 mb-3 group-hover:text-slate-700 transition-colors">
              {{ solutionsData[2]?.title }}
            </h3>
            <p class="text-secondary-800 leading-relaxed text-sm font-semibold">
              {{ solutionsData[2]?.content }}
            </p>
          </div>
          <div
            class="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full rounded-b-2xl transition-all duration-500 bg-gradient-to-br from-amber-500 to-amber-600"></div>
        </div>

        <div
          class="group relative rounded-2xl overflow-hidden p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-secondary-200 shadow-xl">
          <div class="mb-6">
            <div
              class="inline-flex items-center justify-center w-14 h-14 text-secondary-200 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <ng-icon name="tablerAdjustmentsHeart" size="2rem"></ng-icon>
            </div>
          </div>
          <div>
            <h3
              class="font-secondary text-xl font-semibold text-primary-800 mb-3 group-hover:text-slate-700 transition-colors">
              {{ solutionsData[3]?.title }}
            </h3>
            <p class="text-secondary-800 leading-relaxed text-sm font-semibold">
              {{ solutionsData[3]?.content }}
            </p>
          </div>
          <div
            class="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full rounded-b-2xl transition-all duration-500 bg-gradient-to-br from-purple-500 to-purple-600"></div>
        </div>

        <div
          class="group relative rounded-2xl overflow-hidden p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-secondary-200 shadow-xl">
          <div class="mb-6">
            <div
              class="inline-flex items-center justify-center w-14 h-14 text-secondary-200 rounded-xl bg-gradient-to-br from-rose-500 to-rose-600 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <ng-icon name="tablerExchange" size="2rem"></ng-icon>
            </div>
          </div>
          <div>
            <h3
              class="font-secondary text-xl font-semibold text-primary-800 mb-3 group-hover:text-slate-700 transition-colors">
              {{ solutionsData[4]?.title }}
            </h3>
            <p class="text-secondary-800 leading-relaxed text-sm font-semibold">
              {{ solutionsData[4]?.content }}
            </p>
          </div>
          <div
            class="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full rounded-b-2xl transition-all duration-500 bg-gradient-to-br from-rose-500 to-rose-600"></div>
        </div>

        <div
          class="group relative rounded-2xl overflow-hidden p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-secondary-200 shadow-xl">
          <div class="mb-6">
            <div
              class="inline-flex items-center justify-center w-14 h-14 text-secondary-200 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <ng-icon name="matChecklistOutline" size="2rem"></ng-icon>
            </div>
          </div>
          <div>
            <h3
              class="font-secondary text-xl font-semibold text-primary-800 mb-3 group-hover:text-slate-700 transition-colors">
              {{ solutionsData[5]?.title }}
            </h3>
            <p class="text-secondary-800 leading-relaxed text-sm font-semibold">
              {{ solutionsData[5]?.content }}
            </p>
          </div>
          <div
            class="absolute bottom-0 left-0 h-1 w-0 group-hover:w-full transition-all duration-500 bg-gradient-to-br from-indigo-500 to-indigo-600"></div>
        </div>
      </div>
    </div>
  </div>
</section>
